import { FIELDS, TAB_VIEW_SECTIONS, TABS } from '../../../constants';

export const { OVERVIEW } = TABS;
export const {
  CONTACT_INFO,
  FEATURES,
  HOURS,
  MARKETING_MEDIA,
  PROPERTY_DETAILS,
} = TAB_VIEW_SECTIONS[OVERVIEW];
export const {
  [CONTACT_INFO]: CONTACT_INFO_FIELDS,
  [MARKETING_MEDIA]: MARKETING_MEDIA_FIELDS,
  [PROPERTY_DETAILS]: PROPERTY_DETAILS_FIELDS,
  [FEATURES]: NOTES_FEATURES_FIELDS,
} = FIELDS[OVERVIEW];

export const VALIDATION_ERROR_MESSAGES = {
  INVALID_URL: 'Enter a valid URL starting with https://',
  INVALID_YEAR_BUILT: 'Enter a valid year',
  INVALID_ZIP: 'Enter a valid US or CA postal code',
  REQUIRED: 'required',
};
